import React, { ReactElement } from 'react';
import { TIconProps } from './Icons.types';

function QuestionIcon({
  height = 20,
  width = 20,
  iconColor = '#f27a1a',
  ...restProps
}: TIconProps): ReactElement {
  return (
    <svg
      version="1.1"
      data-testid="question-icon"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 1024 1024"
      {...restProps}>
      <title />
      <g id="icomoon-ignore" />
      <path
        fill={iconColor}
        d="M512 0c282.77 0 512 229.23 512 512s-229.23 512-512 512c-282.77 0-512-229.23-512-512s229.23-512 512-512zM512 97.769c-228.774 0-414.231 185.458-414.231 414.231s185.458 414.231 414.231 414.231c228.774 0 414.231-185.458 414.231-414.231s-185.458-414.231-414.231-414.231zM512 666.372c28.419 0 51.457 23.038 51.457 51.457s-23.038 51.457-51.457 51.457c-28.419 0-51.457-23.038-51.457-51.457s23.038-51.457 51.457-51.457zM540.482 231.518c91.502 15.695 158.343 95.097 158.205 187.858 0 61.349-36.121 109.508-92.382 147.016-30.497 20.331-60.408 33.625-81.739 40.735-26.961 8.987-56.102-5.584-65.089-32.544-8.345-25.035 3.622-51.95 26.961-62.863l13.954-5.399 8.712-3.716c13.788-6.128 27.556-13.471 40.114-21.843 30.573-20.382 46.553-41.689 46.554-61.462 0.063-42.655-30.647-79.137-72.689-86.349-39.414-6.761-78.012 14.053-94.346 49.837l-2.964 7.353c-9.431 26.809-38.809 40.896-65.617 31.466s-40.896-38.809-31.466-65.617c30.808-87.577 120.289-140.166 211.791-124.471z"
      />
    </svg>
  );
}

export default QuestionIcon;
